export default __webpack_public_path__ + "static/media/request.89a2e23a.png";